import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { MAGIC_CITY_PAGE_PATH } from "utils/constants/paths";

const MagicCityPage = Loadable(React.lazy(() => import("./View")));

export const MagicCityPageRoute: IRouteItem = {
  path: MAGIC_CITY_PAGE_PATH,
  element: React.createElement(MagicCityPage),
  name: "Magic City",
};
